export default __webpack_public_path__ + "static/media/withdraw-reward-step5.9f0daa39.png";